import { ReportTypes } from '../enums/report-type.enum';
import { downloadReportTypeTranslationMap } from './downloadReportTypeTranslationMap';
import { downloadReportsListInterface } from '../interfaces/download-reports.interface';

export const downloadReportTypeOptions: downloadReportsListInterface[] = [
    {
        isInProgress: false,
        reportType: ReportTypes.LISTINGS_REPORT,
        translationPath: downloadReportTypeTranslationMap[ReportTypes.LISTINGS_REPORT],
        operationName: 'Listings Report',
    },
    {
        isInProgress: false,
        reportType: ReportTypes.DISTRIBUTION_TRACKING_REPORT,
        translationPath: downloadReportTypeTranslationMap[ReportTypes.DISTRIBUTION_TRACKING_REPORT],
        operationName: 'Distribution Tracking Report',
    },
    {
        isInProgress: false,
        reportType: ReportTypes.PREMIER_INN_REPORT,
        translationPath: downloadReportTypeTranslationMap[ReportTypes.PREMIER_INN_REPORT],
        operationName: 'Premier Inn Report',
    },
];
